/* @flow */

import {createAction} from 'redux-act';

import type {WidgetOpensReportDataRequestedAction} from './types';

/*
 * Action creators
 */
export const requestReportData: (
    payload: $PropertyType<WidgetOpensReportDataRequestedAction, 'payload'>
) => WidgetOpensReportDataRequestedAction = createAction('WIDGET_OPENS_REPORT_DATA_REQUESTED');

export const updateReportChartData = createAction('WIDGET_OPENS_REPORT_CHART_DATA_UPDATED');
export const failReportChartData = createAction('WIDGET_OPENS_REPORT_CHART_DATA_FAILED');
